export default __webpack_public_path__ + "static/media/dots.fbc9fbd0.svg";